import { TagPadrao } from './model/tag-padrao';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BodyTag } from './model/body-tag';
import { SetorTag } from './model/setor-startup-tag';


@Component({
  selector: 'setor-primecap',
  templateUrl: './setor-primecap.component.html',
  styleUrls: ['./setor-primecap.component.css']
})
export class SetorPrimecapComponent implements OnInit, OnChanges {

  @Input() setorStartupTag!: SetorTag;
  @Input() height?: string = '28px';
  @Input() width?: string = 'auto';
  tag!: BodyTag;

  constructor(
  ) {}

  ngOnChanges(): void {
    if (!this.setorStartupTag) {
      this.tag = TagPadrao;
  	} else {
      this.tag = {
        backgroundColor: this.setorStartupTag.corTag,
        fontColor: '#292929',
        message: this.setorStartupTag?.nome?.toUpperCase(),
        font: '600 14px/1 \'Open Sans\', sans-serif'
      }
    }

  }

  ngOnInit(): void {
  }
}
